var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdm-stripe',{attrs:{"text":_vm.label,"size":_vm.size,"color":"#54A39D"}})}
var staticRenderFns = []

export { render, staticRenderFns }